import { NotesTab } from "@/entities/notes-tab-content";
import { appRouterPaths } from "@/services/navigation";
import type { RouteProps } from "react-router-dom";

export const contactsNotesRouteV2: RouteProps = {
  path: appRouterPaths.contacts.notes,
  element: <NotesTab />,
};
